<form class="w-100 h-100 form" [formGroup]="dataForm">
  <h4 class="text-center">Detalle del {{ data.rrType }}: {{ data.code }}</h4>
  <button class="btn-close" (click)="onNoClick()"></button>
  <div class="row mx-0 mt-3 pt-0 pb-0 w-100">
    <div class="col-3">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Estado actual</mat-label>
          <input matInput placeholder="Estado actual" formControlName="currentStatus" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-3">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Fecha de registro</mat-label>
          <input matInput placeholder="Fecha de registro" formControlName="dateRegister" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-6">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Detalle de lo sucedido</mat-label>
          <input matInput placeholder="Detalle" formControlName="detail" readonly>
        </mat-form-field>
      </div>
    </div>
    <div *ngIf="data.idType === 1"
      [ngClass]="{'col-6': data.idType === 1 && data.sureId != 3, 'col-3': data.idType === 1 && data.sureId == 3}">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Seguro relacionado</mat-label>
          <input matInput placeholder="Seguro relacionado" formControlName="sure" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-6" *ngIf="data.idType === 1">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Tema asociado</mat-label>
          <input matInput placeholder="Tema asociado" formControlName="theme" readonly>
        </mat-form-field>
      </div>
    </div>

    <div class="col-3" *ngIf="data.idType === 1 && data.sureId == 3">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Placa del vehículo</mat-label>
          <input matInput placeholder="Placa del vehículo" formControlName="licensePlate" readonly>
        </mat-form-field>
      </div>
    </div>


    <div class="col-3" *ngIf="data.idType === 1">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Fecha de Ocurrencia</mat-label>
          <input matInput placeholder="Fecha de Ocurrencia" formControlName="date" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-9" *ngIf="data.idType === 1">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Requerimiento del cliente</mat-label>
          <input matInput placeholder="Requerimiento del cliente" formControlName="request" readonly>
        </mat-form-field>
      </div>
    </div>

    <div class="col-3">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Documento</mat-label>
          <input matInput placeholder="Documento" formControlName="document" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-3">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Nombre</mat-label>
          <input matInput placeholder="Nombre" formControlName="contactName" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-3">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Apellidos</mat-label>
          <input matInput placeholder="Apellidos" formControlName="lastNames" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-3">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Correo electrónico</mat-label>
          <input matInput placeholder="Correo electrónico" formControlName="email" readonly>
        </mat-form-field>
      </div>
    </div>

    <div class="col-3">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Celular</mat-label>
          <input matInput placeholder="Celular" formControlName="cellPhone" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-3">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Distrito</mat-label>
          <input matInput placeholder="Distrito" formControlName="district" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-6">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Vía de contacto</mat-label>
          <input matInput placeholder="Vía de contacto" formControlName="contactWays" readonly>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="mat-elevation-z8 mb-3">
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="statusChanged">
        <th class="code" mat-header-cell *matHeaderCellDef>Estado</th>
        <td class="code" mat-cell *matCellDef="let element"> {{element.statusChanged}} </td>
      </ng-container>
      <ng-container matColumnDef="comment">
        <th class="code" mat-header-cell *matHeaderCellDef>Comentario</th>
        <td class="code" mat-cell *matCellDef="let element"> {{element.comment}} </td>
      </ng-container>
      <ng-container matColumnDef="statusDate">
        <th class="code" mat-header-cell *matHeaderCellDef>Fecha</th>
        <td class="code" mat-cell *matCellDef="let element"> {{element.statusDate}} </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator #paginator [length]="allRegister" [pageIndex]="0" [pageSize]="pageSize" (page)="onPageFired($event)">
      >
    </mat-paginator>
  </div>
  <div class="bottom-button">
    <button class="vs-btn-blue" (click)="onNoClick()">
      Cerrar
    </button>
  </div>
</form>